module.exports = __webpack_public_path__ + "img/address.0d8078c9.svg";